import React from "react";
import { useNavigate } from "react-router-dom";
import about from "../../Asset/19616.jpg";

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col lg:flex-row items-center gap-12 py-16 px-8 max-w-6xl mx-auto">
      {/* Image Section */}
      <div className="relative w-full lg:w-1/2">
        <div className="absolute top-4 left-4 w-full h-full bg-[#b3a58f] -z-10"></div>
        <img src={about} alt="About Us" className="w-full" />
      </div>

      {/* Content Section */}
      <div className="w-full lg:w-1/2">
        <h2 className="text-3xl font-serif font-semibold mb-6">
          CHARETHRI BUSINESS SOLUTIONS LLP
        </h2>

        <p className="text-gray-700 leading-relaxed text-justify mb-4">
          Established in 1997 as <strong>Siddharth Associates</strong> by{" "}
          <strong>Srenivasa M</strong>, the company started as a prime property
          consultancy and documentation services firm. Over the years, it built a
          strong reputation in real estate documentation and consultancy with a
          professional team handling several turnkey projects.
        </p>

        <p className="text-gray-700 leading-relaxed text-justify">
          In 2024, the firm evolved into{" "}
          <strong>CHARETHRI BUSINESS SOLUTIONS LLP</strong> with the unique idea of{" "}
          <em>“One Stop for Land & Building Documentation Services”</em>, now led by{" "}
          <strong>Mr. Chaithania Srinivas</strong> and team, serving Bangalore and
          nearby districts with trusted documentation expertise.
        </p>

        {/* Button */}
        <button
          onClick={() => navigate("/about")}
          className="mt-6 bg-[#b3a58f] text-white px-6 py-3 hover:bg-[#9c8a6d] transition rounded"
        >
          More About Us..
        </button>
      </div>
    </div>
  );
};

export default AboutUs;
